import React, { useState } from "react";
import { translation } from "./Translation";

const DescriptionModal = (props) => {
    const [lang, setLang] = useState(localStorage.getItem("lang") || "fa");
    return (
        <div
            onScroll={(e) => {
                e.stopPropagation();
            }}
            className="wallet-main gift"
        >
            <div className="wallet-modal description">
                <h2>
                    <svg
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M17.5 32.0833C25.5208 32.0833 32.0833 25.5208 32.0833 17.5C32.0833 9.47917 25.5208 2.91667 17.5 2.91667C9.47913 2.91667 2.91663 9.47917 2.91663 17.5C2.91663 25.5208 9.47913 32.0833 17.5 32.0833Z"
                            stroke="#FF9A51"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            opacity="0.6"
                            d="M17.5 11.6667V18.9583"
                            stroke="#FF9A51"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            opacity="0.6"
                            d="M17.4919 23.3333H17.505"
                            stroke="#FF9A51"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    {translation.Products_Description[lang]
                        ? translation.Products_Description[lang]
                        : "توضیحات"}
                </h2>
                <div className="p-box">
                    <p>
                        {props.description.split(`\n`).map(function (item) {
                            return (
                                <span>
                                    {item}
                                    <br />
                                </span>
                            );
                        })}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DescriptionModal;
